﻿import VeilederIasDto from '../Models/VeilederIasDto';
import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';

const ingenSosken = 'c1-ingen';
const ettSosken = 'c2-ett';
const toSosken = 'c3-to';
const treEllerFlereSosken = 'c4-treEllerFlere';

const cValg: RadioButtonValgModel<VeilederIasDto>[] = [
    { id: 'c1', value: ingenSosken, tekst: 'valgSoskenIngen' },
    { id: 'c2', value: ettSosken, tekst: 'valgSoskenEtt' },
    { id: 'c3', value: toSosken, tekst: 'valgSoskenTo' },
    { id: 'c4', value: treEllerFlereSosken, tekst: 'valgSoskenTreEllerFlere' },
];

export default {
    c1_ingenSosken: ingenSosken,
    c2_ettSosken: ettSosken,
    c3_toSosken: toSosken,
    c4_treEllerFlereSosken: treEllerFlereSosken,
    cValg,
};
